import React, { useEffect, useState } from "react";
import { Alert, Container } from "reactstrap";
import { showTopbarInsideAction } from "../../../store/actions";
import { useDispatch } from "react-redux";
import HeaderDefaultToPage from "../../../components/Common/headerDefaultToPage";
import InputSearch from "../../../components/Inputs/InputSearch";

const NO008 = () => {
  document.title = "Defender | Meus Perfis de Acesso";

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(showTopbarInsideAction({}));
  }, []);

  return (
    <React.Fragment>
      <div className="page-content page-config">
        <Container fluid={true} className="dataTable-custom-primary">
          <HeaderDefaultToPage
            title={"Meus Perfis de Acesso"}
          />
          <div className="row content-page my-4">
            <div className="col-lg-4 col-md-5 col-12">
              <div className="bg-white card-content w-100">
                <div className="card-body">
                  <div className="d-flex">
                    <InputSearch 
                      width={"100%"} 
                      height={54} 
                      sizeIcon={24} 
                      placeholder="Busca"
                      inputFontSize={16}
                      onChange={(e) => console.log(e)}
                    /> 
                  </div>
                  <div style={{height: 600, overflowY: "auto", overflowX: "hidden"}}>
                    <div className="row mt-4 group-of-links">
                      <div className="col form-group p-0">
                        <div className="d-flex align-items-center head-group px-3">
                          <div className="d-flex align-items-center gap-3">
                            <div className="logo-img"></div>
                            <span className="label">Carajás - Fortaleza CE</span>
                          </div>
                        </div>
                        <div className="d-flex body-group ">
                          <div className="container-group px-3">
                            <span className="label">Gerente de Compras</span>
                            <div className="d-flex align-items-center gap-2 container-item-body">
                              <div><i className="fas fa-folder fa-3x"></i></div>
                              <div><span className="label">MyOrder</span></div>
                            </div>
                            <div className="d-flex align-items-center gap-2 container-item-body">
                              <div><i className="fas fa-folder fa-3x"></i></div>
                              <div><span className="label">MyOrder</span></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row mt-4 group-of-links">
                      <div className="col form-group p-0">
                        <div className="d-flex align-items-center head-group px-3">
                          <div className="d-flex align-items-center gap-3">
                            <div className="logo-img"></div>
                            <span className="label">Carajás - Fortaleza CE</span>
                          </div>
                        </div>
                        <div className="d-flex body-group ">
                          <div className="container-group px-3">
                            <span className="label">Gerente de Compras</span>
                            <div className="d-flex align-items-center gap-2 container-item-body">
                              <div><i className="fas fa-folder fa-3x"></i></div>
                              <div><span className="label">MyOrder</span></div>
                            </div>
                            <div className="d-flex align-items-center gap-2 container-item-body">
                              <div><i className="fas fa-folder fa-3x"></i></div>
                              <div><span className="label">MyOrder</span></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row mt-4 group-of-links">
                      <div className="col form-group p-0">
                        <div className="d-flex align-items-center head-group px-3">
                          <div className="d-flex align-items-center gap-3">
                            <div className="logo-img"></div>
                            <span className="label">Carajás - Fortaleza CE</span>
                          </div>
                        </div>
                        <div className="d-flex body-group ">
                          <div className="container-group px-3">
                            <span className="label">Gerente de Compras</span>
                            <div className="d-flex align-items-center gap-2 container-item-body">
                              <div><i className="fas fa-folder fa-3x"></i></div>
                              <div><span className="label">MyOrder</span></div>
                            </div>
                            <div className="d-flex align-items-center gap-2 container-item-body">
                              <div><i className="fas fa-folder fa-3x"></i></div>
                              <div><span className="label">MyOrder</span></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col px-3">
              <div className="bg-white card-content w-100 mb-3">
                <div className="card-body">
                  <div className="row py-3 px-3 d-flex align-items-center">
                    <div className="col-6">
                      <div className="d-flex align-items-center gap-4">
                        <div>
                          <i class="fas fa-store fa-4x text-primary-dark"></i>
                        </div>
                        <div className="d-flex flex-column ml-3">
                          <span className="label text-black font-size-20 font-w-600">Maceió - Mangabeiras</span>
                          <span className="label text-black font-size-14 font-w-400">Mangabeiras Alagoas</span>
                        </div>
                      </div>
                    </div>
                    <div className="col-6">
                      <p style={{width: 300}} className="text-black font-size-14 font-w-400">Endereço: Av. Comendador Gustavo Paiva e pela Av. Dona Constança do Góes Monteiro Mangabeiras, Maceió - AL, 2408
Maceió, Brasil
CEP: 57031-530</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-white card-content w-100 mb-3">
                <div className="card-body">
                  <div className="row py-3 px-3 d-flex align-items-center">
                    <div className="col-6">
                      <div className="d-flex align-items-center gap-4">
                        <div>
                          <i class="fas fa-store fa-4x text-primary-dark"></i>
                        </div>
                        <div className="d-flex flex-column ml-3">
                          <span className="label text-black font-size-20 font-w-600">Maceió - Mangabeiras</span>
                          <span className="label text-black font-size-14 font-w-400">Mangabeiras Alagoas</span>
                        </div>
                      </div>
                    </div>
                    <div className="col-6">
                      <p style={{width: 300}} className="text-black font-size-14 font-w-400">Endereço: Av. Comendador Gustavo Paiva e pela Av. Dona Constança do Góes Monteiro Mangabeiras, Maceió - AL, 2408
Maceió, Brasil
CEP: 57031-530</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default NO008;
